import { render, staticRenderFns } from "./binding-weChat.vue?vue&type=template&id=fd49f822&scoped=true&"
import script from "./binding-weChat.vue?vue&type=script&lang=js&"
export * from "./binding-weChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd49f822",
  null
  
)

export default component.exports